
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as loginBmyj_vfPTDaEDqaiGpr84MHO3dLRczQV7ag0uCpdfccMeta } from "/vercel/path0/app/pages/login.vue?macro=true";
import { default as searchNgih0ybV5qUSeNPcIEX1FEvwyzKOOxMTapSm_DszQLwMeta } from "/vercel/path0/app/pages/search.vue?macro=true";
import { default as _91_46_46_46all_93sEEt4ZNCFgMFMOpMIJtjSUgO6jJ5dMsiLMm5EVyBHvIMeta } from "/vercel/path0/app/pages/[...all].vue?macro=true";
import { default as shopwareNoSf5QIFVAuf1CfBymaT3M_OVW34JgvSvZXKpvpME_8Meta } from "/vercel/path0/app/pages/shopware.vue?macro=true";
import { default as wishlist_XHRAoeu_Toi6LFEl_P21LkkWV40M9k8zMkzbClHyfYMeta } from "/vercel/path0/app/pages/wishlist.vue?macro=true";
import { default as indexmmKajtpo4vaJxeWcOwjLcEN5PIMaZnDHcphSMy1aJM8Meta } from "/vercel/path0/app/pages/account/index.vue?macro=true";
import { default as orderMj6GcrMLLdTuRXaQm_FxrdlYBL03J5SA69331iUHjgoMeta } from "/vercel/path0/app/pages/account/order.vue?macro=true";
import { default as cartJ9g66nj6nEV0HLE0LtOqovFA_Xyl0bkRoV2tz5ud3iIMeta } from "/vercel/path0/app/pages/checkout/cart.vue?macro=true";
import { default as indexVeWfjHOJLsBqNjeElmAOg2YwjEcseRV9AvFeuUp3_TgMeta } from "/vercel/path0/app/pages/checkout/index.vue?macro=true";
import { default as reset_45password3yAShUMGjMzBU_YC__2ydKHraLWg7y40dSh0Bh_4UG8Meta } from "/vercel/path0/app/pages/reset-password.vue?macro=true";
import { default as address_rdYUVhK0bBTi2jReOJwRl8fmBhGZeJEdqgSOwYyHagMeta } from "/vercel/path0/app/pages/account/address.vue?macro=true";
import { default as paymentzaZ5eUpDyfJcvkllVDC6X7UemysHI_mIv1nqpibDwRIMeta } from "/vercel/path0/app/pages/account/payment.vue?macro=true";
import { default as profilemclq0JbEWvjxpfUPVJ4r_kH3_leb9erHCoJCap6wDnEMeta } from "/vercel/path0/app/pages/account/profile.vue?macro=true";
import { default as recoverCM6WfMVYF_88wAhT1QySoIcrSImbnytUmBDc8RoW4_AMeta } from "/vercel/path0/app/pages/account/recover.vue?macro=true";
import { default as account820FAFiOQbBfVG_rM_N39xx27o0ATljIHCNMnVjqGEMMeta } from "/vercel/path0/app/pages/checkout/account.vue?macro=true";
import { default as bulkorderDsZ5ve2a_YoDJWFxCRm6t3grzncfOPsfa_kAqN_mq2oMeta } from "/vercel/path0/app/pages/account/bulkorder.vue?macro=true";
import { default as personalize_45step_451R55fJH63LXoAyUEY9AgyyVqssImKmIV7J1CV_n73srEMeta } from "/vercel/path0/app/pages/personalize-step-1.vue?macro=true";
import { default as personalize_45step_452omau0eJUI3Xb7KPl8pgtSB4AtoN9cZsYoNQcQssuP9gMeta } from "/vercel/path0/app/pages/personalize-step-2.vue?macro=true";
import { default as _91id_93GdxWhA4ARP2hsZxNXy1uRiAtbkmY7Y_DWePy1VvYAosMeta } from "/vercel/path0/app/pages/bulkorder/edit/[id].vue?macro=true";
import { default as newsletter_45subscribevjTEY4PncbKnAYYm4hjDiqrNQQ9_xM3Y6t9KL_zYbkYMeta } from "/vercel/path0/app/pages/newsletter-subscribe.vue?macro=true";
import { default as _91id_93DKzNvswlWVcaUCUTunnKpbcpQnQK2Vtd2o72flmZIMwMeta } from "/vercel/path0/app/pages/bulkorder/create/[id].vue?macro=true";
import { default as paidooIgS5QRZFcWqbNX2rKQaHP8ovuWTbxUyeF18gORQbsMeta } from "/vercel/path0/app/pages/checkout/success/[id]/paid.vue?macro=true";
import { default as indexrtOIPvmXoQrF3chcU6Bb4JwVRkVtmiB58R3jH1pbYucMeta } from "/vercel/path0/app/pages/checkout/success/[id]/index.vue?macro=true";
import { default as unpaidHBccg4G33jcXZp_kHb0VLH07pKas4RqRy0WWwXsJLIsMeta } from "/vercel/path0/app/pages/checkout/success/[id]/unpaid.vue?macro=true";
export default [
  {
    name: "login___de-DE",
    path: "/login",
    component: () => import("/vercel/path0/app/pages/login.vue")
  },
  {
    name: "login___fr-CH",
    path: "/fr-CH/login",
    component: () => import("/vercel/path0/app/pages/login.vue")
  },
  {
    name: "search___de-DE",
    path: "/search",
    component: () => import("/vercel/path0/app/pages/search.vue")
  },
  {
    name: "search___fr-CH",
    path: "/fr-CH/search",
    component: () => import("/vercel/path0/app/pages/search.vue")
  },
  {
    name: "all___de-DE",
    path: "/:all(.*)*",
    component: () => import("/vercel/path0/app/pages/[...all].vue")
  },
  {
    name: "all___fr-CH",
    path: "/fr-CH/:all(.*)*",
    component: () => import("/vercel/path0/app/pages/[...all].vue")
  },
  {
    name: "shopware___de-DE",
    path: "/shopware",
    component: () => import("/vercel/path0/app/pages/shopware.vue")
  },
  {
    name: "shopware___fr-CH",
    path: "/fr-CH/shopware",
    component: () => import("/vercel/path0/app/pages/shopware.vue")
  },
  {
    name: "wishlist___de-DE",
    path: "/wishlist",
    component: () => import("/vercel/path0/app/pages/wishlist.vue")
  },
  {
    name: "wishlist___fr-CH",
    path: "/fr-CH/wishlist",
    component: () => import("/vercel/path0/app/pages/wishlist.vue")
  },
  {
    name: "account___de-DE",
    path: "/account",
    meta: indexmmKajtpo4vaJxeWcOwjLcEN5PIMaZnDHcphSMy1aJM8Meta || {},
    component: () => import("/vercel/path0/app/pages/account/index.vue")
  },
  {
    name: "account___fr-CH",
    path: "/fr-CH/account",
    meta: indexmmKajtpo4vaJxeWcOwjLcEN5PIMaZnDHcphSMy1aJM8Meta || {},
    component: () => import("/vercel/path0/app/pages/account/index.vue")
  },
  {
    name: "account-order___de-DE",
    path: "/account/order",
    meta: orderMj6GcrMLLdTuRXaQm_FxrdlYBL03J5SA69331iUHjgoMeta || {},
    component: () => import("/vercel/path0/app/pages/account/order.vue")
  },
  {
    name: "account-order___fr-CH",
    path: "/fr-CH/account/order",
    meta: orderMj6GcrMLLdTuRXaQm_FxrdlYBL03J5SA69331iUHjgoMeta || {},
    component: () => import("/vercel/path0/app/pages/account/order.vue")
  },
  {
    name: "checkout-cart___de-DE",
    path: "/checkout/cart",
    meta: cartJ9g66nj6nEV0HLE0LtOqovFA_Xyl0bkRoV2tz5ud3iIMeta || {},
    component: () => import("/vercel/path0/app/pages/checkout/cart.vue")
  },
  {
    name: "checkout-cart___fr-CH",
    path: "/fr-CH/checkout/cart",
    meta: cartJ9g66nj6nEV0HLE0LtOqovFA_Xyl0bkRoV2tz5ud3iIMeta || {},
    component: () => import("/vercel/path0/app/pages/checkout/cart.vue")
  },
  {
    name: "checkout___de-DE",
    path: "/checkout",
    meta: indexVeWfjHOJLsBqNjeElmAOg2YwjEcseRV9AvFeuUp3_TgMeta || {},
    component: () => import("/vercel/path0/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___fr-CH",
    path: "/fr-CH/checkout",
    meta: indexVeWfjHOJLsBqNjeElmAOg2YwjEcseRV9AvFeuUp3_TgMeta || {},
    component: () => import("/vercel/path0/app/pages/checkout/index.vue")
  },
  {
    name: "reset-password___de-DE",
    path: "/reset-password",
    component: () => import("/vercel/path0/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___fr-CH",
    path: "/fr-CH/reset-password",
    component: () => import("/vercel/path0/app/pages/reset-password.vue")
  },
  {
    name: "account-address___de-DE",
    path: "/account/address",
    meta: address_rdYUVhK0bBTi2jReOJwRl8fmBhGZeJEdqgSOwYyHagMeta || {},
    component: () => import("/vercel/path0/app/pages/account/address.vue")
  },
  {
    name: "account-address___fr-CH",
    path: "/fr-CH/account/address",
    meta: address_rdYUVhK0bBTi2jReOJwRl8fmBhGZeJEdqgSOwYyHagMeta || {},
    component: () => import("/vercel/path0/app/pages/account/address.vue")
  },
  {
    name: "account-payment___de-DE",
    path: "/account/payment",
    meta: paymentzaZ5eUpDyfJcvkllVDC6X7UemysHI_mIv1nqpibDwRIMeta || {},
    component: () => import("/vercel/path0/app/pages/account/payment.vue")
  },
  {
    name: "account-payment___fr-CH",
    path: "/fr-CH/account/payment",
    meta: paymentzaZ5eUpDyfJcvkllVDC6X7UemysHI_mIv1nqpibDwRIMeta || {},
    component: () => import("/vercel/path0/app/pages/account/payment.vue")
  },
  {
    name: "account-profile___de-DE",
    path: "/account/profile",
    meta: profilemclq0JbEWvjxpfUPVJ4r_kH3_leb9erHCoJCap6wDnEMeta || {},
    component: () => import("/vercel/path0/app/pages/account/profile.vue")
  },
  {
    name: "account-profile___fr-CH",
    path: "/fr-CH/account/profile",
    meta: profilemclq0JbEWvjxpfUPVJ4r_kH3_leb9erHCoJCap6wDnEMeta || {},
    component: () => import("/vercel/path0/app/pages/account/profile.vue")
  },
  {
    name: "account-recover___de-DE",
    path: "/account/recover",
    component: () => import("/vercel/path0/app/pages/account/recover.vue")
  },
  {
    name: "account-recover___fr-CH",
    path: "/fr-CH/account/recover",
    component: () => import("/vercel/path0/app/pages/account/recover.vue")
  },
  {
    name: "checkout-account___de-DE",
    path: "/checkout/account",
    meta: account820FAFiOQbBfVG_rM_N39xx27o0ATljIHCNMnVjqGEMMeta || {},
    component: () => import("/vercel/path0/app/pages/checkout/account.vue")
  },
  {
    name: "checkout-account___fr-CH",
    path: "/fr-CH/checkout/account",
    meta: account820FAFiOQbBfVG_rM_N39xx27o0ATljIHCNMnVjqGEMMeta || {},
    component: () => import("/vercel/path0/app/pages/checkout/account.vue")
  },
  {
    name: "account-bulkorder___de-DE",
    path: "/account/bulkorder",
    meta: bulkorderDsZ5ve2a_YoDJWFxCRm6t3grzncfOPsfa_kAqN_mq2oMeta || {},
    component: () => import("/vercel/path0/app/pages/account/bulkorder.vue")
  },
  {
    name: "account-bulkorder___fr-CH",
    path: "/fr-CH/account/bulkorder",
    meta: bulkorderDsZ5ve2a_YoDJWFxCRm6t3grzncfOPsfa_kAqN_mq2oMeta || {},
    component: () => import("/vercel/path0/app/pages/account/bulkorder.vue")
  },
  {
    name: "personalize-step-1___de-DE",
    path: "/personalize-step-1",
    meta: personalize_45step_451R55fJH63LXoAyUEY9AgyyVqssImKmIV7J1CV_n73srEMeta || {},
    component: () => import("/vercel/path0/app/pages/personalize-step-1.vue")
  },
  {
    name: "personalize-step-1___fr-CH",
    path: "/fr-CH/personalize-step-1",
    meta: personalize_45step_451R55fJH63LXoAyUEY9AgyyVqssImKmIV7J1CV_n73srEMeta || {},
    component: () => import("/vercel/path0/app/pages/personalize-step-1.vue")
  },
  {
    name: "personalize-step-2___de-DE",
    path: "/personalize-step-2",
    meta: personalize_45step_452omau0eJUI3Xb7KPl8pgtSB4AtoN9cZsYoNQcQssuP9gMeta || {},
    component: () => import("/vercel/path0/app/pages/personalize-step-2.vue")
  },
  {
    name: "personalize-step-2___fr-CH",
    path: "/fr-CH/personalize-step-2",
    meta: personalize_45step_452omau0eJUI3Xb7KPl8pgtSB4AtoN9cZsYoNQcQssuP9gMeta || {},
    component: () => import("/vercel/path0/app/pages/personalize-step-2.vue")
  },
  {
    name: "bulkorder-edit-id___de-DE",
    path: "/bulkorder/edit/:id()",
    meta: _91id_93GdxWhA4ARP2hsZxNXy1uRiAtbkmY7Y_DWePy1VvYAosMeta || {},
    component: () => import("/vercel/path0/app/pages/bulkorder/edit/[id].vue")
  },
  {
    name: "bulkorder-edit-id___fr-CH",
    path: "/fr-CH/bulkorder/edit/:id()",
    meta: _91id_93GdxWhA4ARP2hsZxNXy1uRiAtbkmY7Y_DWePy1VvYAosMeta || {},
    component: () => import("/vercel/path0/app/pages/bulkorder/edit/[id].vue")
  },
  {
    name: "newsletter-subscribe___de-DE",
    path: "/newsletter-subscribe",
    component: () => import("/vercel/path0/app/pages/newsletter-subscribe.vue")
  },
  {
    name: "newsletter-subscribe___fr-CH",
    path: "/fr-CH/newsletter-subscribe",
    component: () => import("/vercel/path0/app/pages/newsletter-subscribe.vue")
  },
  {
    name: "bulkorder-create-id___de-DE",
    path: "/bulkorder/create/:id()",
    meta: _91id_93DKzNvswlWVcaUCUTunnKpbcpQnQK2Vtd2o72flmZIMwMeta || {},
    component: () => import("/vercel/path0/app/pages/bulkorder/create/[id].vue")
  },
  {
    name: "bulkorder-create-id___fr-CH",
    path: "/fr-CH/bulkorder/create/:id()",
    meta: _91id_93DKzNvswlWVcaUCUTunnKpbcpQnQK2Vtd2o72flmZIMwMeta || {},
    component: () => import("/vercel/path0/app/pages/bulkorder/create/[id].vue")
  },
  {
    name: "checkout-success-id-paid___de-DE",
    path: "/checkout/success/:id()/paid",
    component: () => import("/vercel/path0/app/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-paid___fr-CH",
    path: "/fr-CH/checkout/success/:id()/paid",
    component: () => import("/vercel/path0/app/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id___de-DE",
    path: "/checkout/success/:id()",
    component: () => import("/vercel/path0/app/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id___fr-CH",
    path: "/fr-CH/checkout/success/:id()",
    component: () => import("/vercel/path0/app/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id-unpaid___de-DE",
    path: "/checkout/success/:id()/unpaid",
    component: () => import("/vercel/path0/app/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "checkout-success-id-unpaid___fr-CH",
    path: "/fr-CH/checkout/success/:id()/unpaid",
    component: () => import("/vercel/path0/app/pages/checkout/success/[id]/unpaid.vue")
  }
]